// extracted by mini-css-extract-plugin
module.exports = {"root":"NotificationBox_root__3OSqu","notificationText":"NotificationBox_notificationText__910AF"};